<template>
  <rbz-modal-dialog
    :show="modalDisplayed"
    :title="
      sessionRemainingTime > 0 ? 'Your session is about to expire' : 'Your session has expired!'
    "
    :primary-btn-title="sessionRemainingTime > 0 ? 'Refresh Session' : 'Login'"
    @onPrimaryBtnClick="sessionRemainingTime > 0 ? refreshSession() : logout()"
    @closeModal="modalDisplayed = false"
    size="medium"
  >
    <template #content>
      <template v-if="sessionRemainingTime > 0">
        {{ $t('idleModal.expireTimer') }}
        <span class="has-text-weight-bold">
          {{ sessionRemainingTimeClock }}
        </span>
      </template>
      <template v-else>
        {{ $t('idleModal.pleaseLogin') }}
      </template>
    </template>
  </rbz-modal-dialog>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { mapStores } from 'pinia';
import { useUserStore } from '@/store/UserStore';
import _ from 'lodash';
import RequestsUtils from '@/helpers/RequestsUtils';
import RbzModalDialog from '@/components/RbzModalDialog.vue';

export default defineComponent({
  name: 'IdleModal',
  components: { RbzModalDialog },
  data() {
    return {
      modalDisplayed: false,
    };
  },
  watch: {
    sessionRemainingTime: {
      handler: function (val) {
        this.modalDisplayed = _.isFinite(val);
      },
      immediate: true,
    },
  },
  computed: {
    sessionRemainingTime(): number {
      return this.userStore.sessionRemainingTime;
    },

    sessionRemainingTimeClock(): string {
      const sessionRemainingTime = this.sessionRemainingTime;
      const remainingMinutes = Math.floor(sessionRemainingTime / 60);
      const remainingSeconds = sessionRemainingTime % 60;
      const formattedRemainingMinutes =
        remainingMinutes < 10 ? `0${remainingMinutes}` : remainingMinutes;
      const formattedRemainingSeconds =
        remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds;
      return `${formattedRemainingMinutes}:${formattedRemainingSeconds}`;
    },

    ...mapStores(useUserStore),
  },
  methods: {
    refreshSession() {
      RequestsUtils.sendRequest({ methodName: 'GET', url: 'health' });
    },

    async logout() {
      await this.userStore.logout();
    },
  },
});
</script>
